var map = {
	"./error": "22b7",
	"./error.json": "22b7",
	"./event": "8d7b",
	"./event.json": "8d7b",
	"./fire": "14eb",
	"./fire.json": "14eb",
	"./paper": "a1e2",
	"./paper.json": "a1e2",
	"./ton": "f61a",
	"./ton.json": "f61a",
	"./wait": "16ee",
	"./wait.json": "16ee",
	"./wallet": "d967",
	"./wallet.json": "d967",
	"./win": "1cc4",
	"./win.json": "1cc4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e5de";